import { render } from "./allRooms.vue?vue&type=template&id=64702135&scoped=true"
import script from "./allRooms.vue?vue&type=script&lang=js"
export * from "./allRooms.vue?vue&type=script&lang=js"

import "./allRooms.vue?vue&type=style&index=0&id=64702135&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64702135"]])

export default __exports__